// @flow
import styled from "styled-components"
import StyledLink from "components/StyledLink"

export const Toggle = styled(StyledLink)`
  display: flex;
  align-items: center;
  margin-left: 3rem;
  cursor: pointer;
`
export const MenuLinks = styled.div`
  padding: 1rem 0;
`

export const MenuLink = styled(StyledLink)`
  display: block;
  font-size: 1.6rem;
  color: ${(props) => props.theme.color.primaryText};
  line-height: 4rem;
  padding: 0 2rem;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.color.lightGray};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/AvatarMenu/styled.js